import PaginatedResult from '@/shared/dtos/PaginatedResult'
import { HttpService, ObservableService } from '@/shared/services'
import {
  BackgroundProcess,
  BackgroundProcessListParams,
  CreateBackgroundProcessDto,
} from './interfaces'

const http = new HttpService()
const BASE_PATH = '/backgroundProcesses'
export const BACKGROUND_PROCESS_EVENTS_KEY = 'background-processes:events'

const observableService = ObservableService.getInstance()

const emitRefreshEvent = (payload: unknown) => {
  if (!observableService.getObservable(BACKGROUND_PROCESS_EVENTS_KEY)) {
    observableService.createObservable(BACKGROUND_PROCESS_EVENTS_KEY)
  }

  observableService.emitValue(BACKGROUND_PROCESS_EVENTS_KEY, payload)
}

export const createBackgroundProcess = async (
  dto: CreateBackgroundProcessDto
) => {
  const response = await http.post(BASE_PATH, dto)
  emitRefreshEvent({ action: 'created' })
  return response.data
}

export const listBackgroundProcesses = async (
  params: BackgroundProcessListParams = {}
): Promise<PaginatedResult<BackgroundProcess>> => {
  const query = new URLSearchParams()

  const limit = params.limit ?? 10
  const offset = params.offset ?? 1

  query.append('limit', limit.toString())
  query.append('offset', offset.toString())

  if (params.status) {
    query.append('status', params.status)
  }

  if (params.type) {
    query.append('type', params.type)
  }

  if (params.status) {
    query.append('status', params.status)
  }

  if (params.type) {
    query.append('type', params.type)
  }

  const url = query.toString() ? `${BASE_PATH}?${query.toString()}` : BASE_PATH

  const response = await http.get<PaginatedResult<BackgroundProcess>>(url)
  return response.data
}
